<template>
  <div class="expander" :class="{ opened: show }">
    <button class="expander-button" @click="toggle">
      <slot name="header"></slot>
    </button>
    <transition name="expander-transition"
                v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter"
                v-on:before-leave="beforeLeave" v-on:leave="leave">
      <div class="expander-hidden" v-show="show">
        <div class="expander-hidden-inner">
          <slot name="body"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Expander",
  props: {
    initPosition: {
      type: String,
      default: "hidden",
    }
  },
  data() {
    return {
      show: this.initPosition !== 'hidden'
    }
  },
  methods: {
    toggle() {
      this.show = !this.show
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      const width = getComputedStyle(el).width;

      el.style.width = width;
      el.style.position = 'absolute';
      el.style.visibility = 'hidden';
      el.style.height = 'auto';

      const height = getComputedStyle(el).height;

      el.style.width = null;
      el.style.position = null;
      el.style.visibility = null;
      el.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(el).height;

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        el.style.height = height;
      });
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      const height = getComputedStyle(el).height;

      el.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(el).height;

      requestAnimationFrame(() => {
        el.style.height = 0;
      });
    },
    afterEnter(el) {
      el.style.height = 'auto';
    },
  }
}
</script>
